export const createImage = (url) =>
    new Promise((resolve, reject) => {
        const image = new Image();
        image.addEventListener("load", () => resolve(image));
        image.addEventListener("error", (error) => reject(error));
        image.setAttribute("crossOrigin", "anonymous"); // needed to avoid cross-origin issues on CodeSandbox
        image.src = url;
    });

export function getRadianAngle(degreeValue) {
    return (degreeValue * Math.PI) / 180;
}

/**
 * Returns the new bounding area of a rotated rectangle.
 */
export function rotateSize(width, height, rotation) {
    const rotRad = getRadianAngle(rotation);

    return {
        width: Math.abs(Math.cos(rotRad) * width) + Math.abs(Math.sin(rotRad) * height),
        height: Math.abs(Math.sin(rotRad) * width) + Math.abs(Math.cos(rotRad) * height),
    };
}

export async function getCroppedImg(imageSrc, pixelCrop, rotation = 0, dimensions, flip = { horizontal: false, vertical: false }, allowedExtension) {
    const image = await createImage(imageSrc);
    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");

    if (!ctx) {
        return null;
    }

    // Calculate rotation bounding box
    const rotRad = getRadianAngle(rotation);
    const { width: bBoxWidth, height: bBoxHeight } = rotateSize(image.width, image.height, rotation);

    // Set canvas size to fit the rotated image
    canvas.width = bBoxWidth;
    canvas.height = bBoxHeight;
    ctx.clearRect(0, 0, canvas.width, canvas.height);

    // Translate to center, rotate, then draw image
    ctx.translate(bBoxWidth / 2, bBoxHeight / 2);
    ctx.rotate(rotRad);
    ctx.scale(flip.horizontal ? -1 : 1, flip.vertical ? -1 : 1);
    ctx.drawImage(image, -image.width / 2, -image.height / 2);

    // Create a new canvas for the cropped area
    const croppedCanvas = document.createElement("canvas");
    croppedCanvas.width = pixelCrop.width;
    croppedCanvas.height = pixelCrop.height;
    const croppedCtx = croppedCanvas.getContext("2d");

    if (!croppedCtx) {
        return null;
    }

    // Extract the cropped area
    croppedCtx.clearRect(0, 0, croppedCanvas.width, croppedCanvas.height);
    croppedCtx.drawImage(canvas, pixelCrop.x, pixelCrop.y, pixelCrop.width, pixelCrop.height, 0, 0, pixelCrop.width, pixelCrop.height);

    // Create final canvas for resizing
    const finalCanvas = document.createElement("canvas");
    finalCanvas.width = dimensions.width;
    finalCanvas.height = dimensions.height;
    const finalCtx = finalCanvas.getContext("2d");

    if (!finalCtx) {
        return null;
    }

    finalCtx.clearRect(0, 0, finalCanvas.width, finalCanvas.height);
    finalCtx.drawImage(croppedCanvas, 0, 0, pixelCrop.width, pixelCrop.height, 0, 0, dimensions.width, dimensions.height);

    return finalCanvas.toDataURL(allowedExtension, 0.92);
}
